import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "linebreaks" })
export class LinebreaksPipe implements PipeTransform {
  public transform(value: string): string {
    return value?.split("\n").join("<br/>");
  }
}
